import { Fade } from "react-awesome-reveal";
import CalendlyCustomButton from "../CalendlyCustomButton";
import Gradient from "../Gradient";
import TipBg from "../../assets/images/support-bg.png";

const FlowSection = ({ data, anchorId }) => {
  if (!data) return null;

  const { title, subTitle, tip } = data;

  return (
    <section className="section flow-section flex-wrapper" id={anchorId}>
      <div className="flex-container section-container">
        <div className="flow-header">
          <div className="flow-header__left">
            <span className="subTitle">{subTitle}</span>
            <h2>{title}</h2>
          </div>
          <div className="flow-header__right">
            {/* <Fade direction="right" duration={1000} cascade>
              <img className="bonus-img" src={BonusImg} alt="bonus" />
            </Fade> */}
            <Fade direction="right" duration={2000} cascade triggerOnce>
              <div className="flow-header__right-info">
                <img className="info-bg" src={TipBg} alt="paper" />
                <span className="info">{tip}</span>
              </div>
            </Fade>
            <Gradient
              imageName="gradient6"
              className="gradientPulse"
              right="initial"
              bottom="-200px"
              left="-300px"
              width="600px"
              height="600px"
            />
          </div>
        </div>
        <div className="flow-main">
          {data.FlowItem?.map((item, index) => (
            <div key={item.id} className="service-item">
              <span>{`0${index + 1}`}</span>
              <div className="service-item__info">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="flow-bottom">
          <CalendlyCustomButton />
        </div>
      </div>
      <Gradient imageName="gradient7" className="gradientFloat" right="initial" bottom="-70%" left="0" />
    </section>
  );
};

export default FlowSection;
